import { Head, usePage } from "@inertiajs/react";
import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import HomesApp from "../../homes/App";

// Auto-resolved page for HomesController#index when the
// `homepage_rebrand_v1` FeatureToggle is ON.
//
// Props (from Rails controller via render_inertia):
//   theme: 'dark' | 'light' — driven by dark_mode_v1 FeatureToggle. Default 'light'.
//   banners: Array<{ id, media_type, url, alt, link, srcset }> — serialized
//            BannerV2 records with `status: :on`. Empty array if no banners
//            are published; HeroBanner then renders a brand-gradient
//            placeholder instead of real content.
export default function Index() {
  const {
    theme = "light",
    banners = [],
    webinars_index_enabled: webinarsIndexEnabled = false,
    video_pembelajaran_index_enabled: videoPembelajaranIndexEnabled = false,
  } = usePage().props;

  const firstBanner = banners[0];

  return (
    <>
      <Head>
        <title>Taxsam Learning Center — #SemuaBisaPahamPajak</title>
        <meta
          name="description"
          content="Pelatihan sertifikasi pajak Brevet A/B/C, webinar, dan video pembelajaran pajak terlengkap di Indonesia."
        />
        {/* LCP hint: the first hero banner is above-the-fold on every load. */}
        {firstBanner &&
          firstBanner.media_type !== "video" &&
          firstBanner.url && (
            <link
              rel="preload"
              as="image"
              href={firstBanner.url}
              fetchpriority="high"
            />
          )}
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <HomesApp
          theme={theme}
          banners={banners}
          webinarsIndexEnabled={webinarsIndexEnabled}
          videoPembelajaranIndexEnabled={videoPembelajaranIndexEnabled}
        />
      </ProvideLoggedInUser>
    </>
  );
}
